import { useEffect, useState, useCallback } from "react";

// Загружает данные через loader(), перезагружает по событию 'ingest-done'.
export function useData(loader, deps = []) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const d = await loader();
      setData(d);
      setError(null);
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  useEffect(() => {
    load();
    const handler = () => load();
    window.addEventListener("ingest-done", handler);
    return () => window.removeEventListener("ingest-done", handler);
  }, [load]);

  return { data, loading, error, reload: load };
}
